var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aha-profanity-filter',{attrs:{"text":_vm.text,"filteringProfanity":!!_vm.$store.state.presentation.filteringProfanity}})}
var staticRenderFns = []

export { render, staticRenderFns }